module.exports = __webpack_public_path__ + "static/media/1274_1210_elements_bio_provideFeedback.81a2d05f.png";